import { RIGReducer } from "./RIG.reducer";
import { RIGMethods, RIGStore } from "./RIG.state";

// ✅ Reusable store methods
export const createRIGActions = (set: any, get: () => RIGStore): Pick<RIGStore, RIGMethods> => ({
    dispatch: action => set((state: RIGStore) => RIGReducer(state, action)),

    getDisclosureRIGs: () => {
        return get().disclosureGuides;
    },

    getTopicRIGs: () => {
        return get().topicGuides;
    },

    getSelectedTopicRIGs: (selectedTopicIDs: number[]) => {
        const availableTopicRIGs = get().topicGuides;
        const selectedTopics = availableTopicRIGs.filter(topic =>
            selectedTopicIDs.includes(topic.topicId)
        );
        return selectedTopics;
    },
});
